import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseModal } from '$icons/uncolored/Close.svg';

const SPKRequestInterviewModal = ({
  candidateName,
  isLoading,
  onCancel,
  onConfirm,
}: {
  candidateName: string;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  const [t] = useTranslation('global');

  return (
    <div
      data-testid="spkRequestInterviewModal"
      className="max-w-2xl w-full bg-white p-4 md:p-8 mx-2 rounded-2xl relative"
    >
      <div>
        <span className="font-bold">{t('ConfirmRequestInterview.Title')}</span>
        <button aria-label="close modal" type="button" onClick={onCancel}>
          <CloseModal className="absolute right-0 top-0 mr-2 mt-2 stroke-employer-primary" />
        </button>
      </div>
      <hr className="my-4" />
      <p className="text-sm">{t('ConfirmRequestInterview.Text')}</p>
      <p className="text-sm font-semibold mt-1">{candidateName}</p>
      <div className="flex flex-row gap-6 justify-end items-center">
        <button
          type="button"
          className="text-employer-primary"
          onClick={onCancel}
        >
          {t('ConfirmRequestInterview.GoBack')}
        </button>
        <button
          type="button"
          className="text-white bg-employer-primary rounded p-3 disabled:opacity-50"
          disabled={isLoading}
          onClick={onConfirm}
        >
          {t('ConfirmRequestInterview.Accept')}
        </button>
      </div>
    </div>
  );
};

export default SPKRequestInterviewModal;
